import { useSyncExternalStore } from "react";

// The site is live once the first document has hydrated; pages mounted by later navigations are
// interactive from their first render.
let hydrated = false;
const listeners = new Set<() => void>();

/** Called once, after the first document hydrates (routes/__root.tsx). */
export function markHydrated() {
  if (hydrated) return;
  hydrated = true;
  // When the page became interactive, for performance tools and field measurements.
  performance.mark("drate:hydrated");
  for (const listener of listeners) listener();
}

/**
 * Whether interactive controls can replace their server-rendered fallbacks (a plain form, a list
 * of links). The server and the first hydration render the fallback, so their markup matches.
 */
export function useHydrated() {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => hydrated,
    () => false,
  );
}
